module.exports = __webpack_public_path__ + "img/skull_12_bj.435a063f.png";